import type { Dispatch, SetStateAction } from "react";
import Button from "../../../shared/components/Button";
import type { AdminTournamentBracketMatch } from "../services/eventRegistrationAdminService";
import { matchCodeForRound, roundLabel } from "../utils/tournamentOperations";

type ManualPair = {
  registrationId: number;
  label: string;
};

export type AdminTournamentMatchupModalState = {
  match: AdminTournamentBracketMatch;
  sideARegistrationId: string;
  sideBRegistrationId: string;
};

type AdminTournamentMatchupModalProps = {
  manualPairs: ManualPair[];
  modal: AdminTournamentMatchupModalState;
  onClose: () => void;
  onSave: () => void;
  saving: boolean;
  setModal: Dispatch<
    SetStateAction<AdminTournamentMatchupModalState | null>
  >;
};

export default function AdminTournamentMatchupModal({
  manualPairs,
  modal,
  onClose,
  onSave,
  saving,
  setModal,
}: AdminTournamentMatchupModalProps) {
  const isGroupMatch =
    String(modal.match.stage || "").toLowerCase() === "group" ||
    ["group", "group_stage"].includes(
      String(modal.match.roundCode || "").toLowerCase(),
    );
  const matchCode = matchCodeForRound(
    modal.match.roundCode,
    modal.match.matchNumber,
  );

  return (
    <div className="admin-tournament-score-modal" role="dialog" aria-modal="true">
      <div className="admin-tournament-score-dialog">
        <div className="admin-tournament-score-dialog-head">
          <h5>Editar confronto</h5>
          <Button type="button" variant="ghost" onClick={onClose}>
            Fechar
          </Button>
        </div>
        <p>
          {isGroupMatch ? `Jogo ${modal.match.matchNumber}` : matchCode} ·{" "}
          {roundLabel(modal.match.roundCode, modal.match.roundNumber)}
        </p>
        <div className="admin-tournament-matchup-edit">
          <label className="field">
            <span>Dupla A</span>
            <select
              value={modal.sideARegistrationId}
              onChange={(event) =>
                setModal((current) =>
                  current
                    ? { ...current, sideARegistrationId: event.target.value }
                    : current,
                )
              }
            >
              <option value="">Selecione</option>
              {manualPairs.map((pair) => (
                <option
                  key={`matchup-a-${pair.registrationId}`}
                  value={pair.registrationId}
                >
                  {pair.label}
                </option>
              ))}
            </select>
          </label>
          <label className="field">
            <span>Dupla B</span>
            <select
              value={modal.sideBRegistrationId}
              onChange={(event) =>
                setModal((current) =>
                  current
                    ? { ...current, sideBRegistrationId: event.target.value }
                    : current,
                )
              }
            >
              <option value="">Selecione</option>
              {manualPairs.map((pair) => (
                <option
                  key={`matchup-b-${pair.registrationId}`}
                  value={pair.registrationId}
                >
                  {pair.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="admin-tournament-ops-actions">
          <Button type="button" variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button type="button" variant="primary" disabled={saving} onClick={onSave}>
            Salvar confronto
          </Button>
        </div>
      </div>
    </div>
  );
}
